import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, Components, FontFamily, FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.COMPONENT_TABS;

export const StyledComponentTabs = styled.div`

`;

export const TabsContainer = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;

  ${Breakpoints.mobile(css`
    flex-direction: column;
  `)}
`;

export const ComponentContainer = styled.div``;

export const IndividualTabWrapper = styled.li`
  display: flex;
  width: 100%;
  margin-right: 10px;
  margin-bottom: 0;
  text-align: left;
  position: relative;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }

  ${Breakpoints.mobile(css`
    margin-right: 0;
    margin-bottom: 15px;
  `)}
`;

export const IndividualTab = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  width: 100%;
  text-align: left;

  ${Breakpoints.mobile(css`
    display: block;
  `)}
`;

export const ActiveTabTopAccent = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 8px;
  top: 0px;
  background-color:  ${({ $colorProfile }) => themeUtil(Prop.ELEMENT, CPNT, $colorProfile)};

  ${Breakpoints.mobile(css`
    display: none;
  `)}
`;

export const ActiveTabConnector = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 25px;
  bottom: ${({ $adjustHeight }) => ((!$adjustHeight) ? '-19px' : '-25px')};
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};

  ${Breakpoints.mobile(css`
    display: none;
  `)}
`;

export const TabButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
  height: 55px;

  ${({ $activeTab, $colorProfile }) => !$activeTab && `
    &:focus {
      outline: 2px solid ${themeUtil(Prop.BORDER, CPNT, $colorProfile)};
      outline-offset: 2px;
    }
  `};

  ${Breakpoints.mobile(css`
    padding: 10px 17px;
  `)}
`;

export const TabTitle = styled.h3`
  display: inline-block;
  margin: 0;
  padding-left: 10px;
  line-height: 22px;
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG50, undefined, undefined, CPNT, 'tab-title')};
  color: ${({ $colorProfile }) => themeUtil(Prop.HEADER, CPNT, $colorProfile)};
  text-align: left;

  ${Breakpoints.mobile(css`
    padding: 0 43px 0 15px;
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG50, undefined, undefined, CPNT, 'tab-title-mobile')};
  `)}

  ${Breakpoints.small(css`
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined, CPNT, 'tab-title-mobile')};
  `)}
`;

export const TabButtonIcon = styled(Icon)`
  margin-left: 5px;
  min-width: 25px;
  max-height: 40px;

  svg {
    fill: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
  }
`;

export const AccordionIndicator = styled(Icon)`
  animation-direction: alternate;
  transition: transform 0.5s ease-in-out;
  position: absolute;
  right: 20px;

  ${({ $activeTab }) => {
    if ($activeTab) {
      return 'transform: rotate(180deg);';
    }

    return 'transform: rotate(0deg);';
  }}

  svg {
    fill: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
  }

  @media only screen and (max-width: (440px - 1px)) {
    position: static;
    padding-left: 5px;
  }
`;
